"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
var prop_types_1 = __importDefault(require("prop-types"));
function ListItem(_a) {
    var role = _a.role, permissions = _a.permissions;
    var _b = react_1.useState(), search = _b[0], setSearch = _b[1];
    var _c = react_1.useState(false), dropdown = _c[0], setDropdown = _c[1];
    var _d = react_1.useState(permissions), filteredPermissions = _d[0], setFilteredPermissions = _d[1];
    var _e = ra_fetch_1.useApi('auth').update('roles', {
        id: role.id,
        permissions: role.permissions,
    }), updateRole = _e[0], setUpdateRole = _e[1], updateRoleSubmit = _e[2];
    react_1.useEffect(function () {
        if (search) {
            var newPermissions = permissions.filter(function (permission) { return permission.name.includes(search); });
            setFilteredPermissions(newPermissions);
        }
        else {
            setFilteredPermissions(permissions);
        }
    }, [search]);
    return react_1.default.createElement("div", null,
        react_1.default.createElement(storybook_1.Lists.Item, { className: 'mb-2' },
            react_1.default.createElement(storybook_1.Lists.Content, null,
                react_1.default.createElement("div", { className: 'w-full flex items-center cursor-pointer', onClick: function () { return setDropdown(!dropdown); } },
                    react_1.default.createElement(storybook_1.Texts.Primary, null, role.label),
                    react_1.default.createElement(storybook_1.Icons.Icon, { name: 'chevron-down', className: "w-5 ml-auto mx-2 text-" + (role.hidden ? 'primary' : 'secondary') + " " + (dropdown ? 'transform rotate-180' : '') })))),
        dropdown &&
            react_1.default.createElement("div", { className: 'storybook-roles-dropdown grid grid-cols-12 gap-2' },
                react_1.default.createElement(storybook_1.Forms.Input, { type: 'text', value: search, placeholder: 'Zoeken...', onChange: function (value) { return setSearch(value); }, className: 'mb-4 mt-4 col-span-12' }),
                filteredPermissions.map(function (permission, index) { return (react_1.default.createElement("div", { key: index, className: 'col-span-12 md:col-span-6 lg:col-span-4' },
                    react_1.default.createElement(storybook_1.Roles.Permission, { permission: permission, role: role, updateRole: updateRole, setUpdateRole: setUpdateRole, updateRoleSubmit: updateRoleSubmit }))); })));
}
exports.default = ListItem;
ListItem.propTypes = {
    /**
     * Role object
     */
    role: prop_types_1.default.object,
    /**
     * Permissions array
     */
    permissions: prop_types_1.default.array,
};
ListItem.defaultProps = {};
